/* eslint-disable no-unused-vars */
import axios from "axios";
import UseAlert from "../components/alert/UseAlert";
import { rest_api_url } from "../constants/urls";
import { removeLocalStorageOnSignOut } from "../hooks/General";
import { getSupportGrant, goToSupportExpired, isInSupportMode } from "./supportGrant";

export default class ApiService {
  static post(url, resolve, reject, body, auth, extraHeaders) {
    const [alert, alert_notify] = UseAlert();
    let supportGrant = getSupportGrant();
    let token = localStorage.getItem("access_token");
    let headers = this.getHeaders();
    if (extraHeaders) {
      headers = { ...headers, ...extraHeaders };
    }
    let initObject = {
      headers,
    };
    if (auth) {
      if (supportGrant || token) {
        axios
          .post(url, body, initObject)
          .then((data) => {
            resolve(data.data);
          })
          .catch((error) => {
            if (error.response?.data?.error?.message) {
              alert_notify("error", error.response.data.error.message);
            }
            if (error?.response?.status === 401) {
              if (isInSupportMode()) {
                goToSupportExpired();
                return;
              }
              if (url === "v1/user/sign_out") {
                removeLocalStorageOnSignOut();
                window.location.href = "/login";
              } else {
                this.updateAccessToken(() => this.post(url, resolve, reject, body, auth));
              }
            } else if (error?.response?.status === 403) {
              if (isInSupportMode()) {
                reject(error?.response?.data?.error);
                return;
              }
              removeLocalStorageOnSignOut();
              window.location.href = "/login";
            } else if (error?.response?.data?.error?.message?.code === "NotAuthorizedException") {
              if (isInSupportMode()) {
                goToSupportExpired();
                return;
              }
              this.updateAccessToken(() => this.post(url, resolve, reject, body, auth));
            } else {
              reject(error?.response?.data?.error);
            }
          });
      } else {
        this.updateAccessToken(() => this.post(url, resolve, reject, body, auth));
      }
    } else {
      axios
        .post(url, body, initObject)
        .then((data) => {
          resolve(data.data);
        })
        .catch((error) => {
          reject(error?.response?.data?.error);
        });
    }
  }

  static get(url, resolve, reject, auth, extraHeaders) {
    let supportGrant = getSupportGrant();
    let token = localStorage.getItem("access_token");
    const [alert, alert_notify] = UseAlert();
    let headers = this.getHeaders();
    if (extraHeaders) {
      headers = { ...headers, ...extraHeaders };
    }
    let initObject = {
      headers,
    };
    if (auth) {
      if (supportGrant || token) {
        axios
          .get(url, initObject)
          .then((data) => {
            resolve(data.data);
          })
          .catch((error) => {
            if (error.response?.data?.error?.message) {
              alert_notify("error", error.response.data.error.message);
            }
            if (error?.response?.status === 401) {
              if (isInSupportMode()) {
                goToSupportExpired();
                return;
              }
              this.updateAccessToken(() => this.get(url, resolve, reject, auth));
            } else if (error?.response?.status === 403) {
              if (isInSupportMode()) {
                reject(error?.response?.data?.error);
                return;
              }
              removeLocalStorageOnSignOut();
              window.location.href = "/login";
            } else if (error?.response?.data?.error?.message?.code === "NotAuthorizedException") {
              if (isInSupportMode()) {
                goToSupportExpired();
                return;
              }
              this.updateAccessToken(() => this.get(url, resolve, reject, auth));
            } else {
              reject(error?.response?.data?.error);
            }
          });
      } else {
        this.updateAccessToken(() => this.get(url, resolve, reject, auth));
      }
    } else {
      axios
        .get(url)
        .then((data) => {
          resolve(data.data);
        })
        .catch((error) => {
          reject(error?.response?.data?.error);
        });
    }
  }

  static put(url, resolve, reject, body, auth, extraHeaders) {
    let supportGrant = getSupportGrant();
    let token = localStorage.getItem("access_token");
    const [alert, alert_notify] = UseAlert();
    let headers = this.getHeaders();
    if (extraHeaders) {
      headers = { ...headers, ...extraHeaders };
    }
    let initObject = {
      headers,
    };
    if (auth) {
      if (supportGrant || token) {
        axios
          .put(url, body, initObject)
          .then((data) => {
            resolve(data.data);
          })
          .catch((error) => {
            if (error.response?.data?.error?.message) {
              alert_notify("error", error.response.data.error.message);
            }
            if (error?.response?.status === 401) {
              if (isInSupportMode()) {
                goToSupportExpired();
                return;
              }
              if (url === "v1/user/sign_out") {
                removeLocalStorageOnSignOut();
                window.location.href = "/login";
              } else {
                this.updateAccessToken(() => this.put(url, resolve, reject, body, auth));
              }
            } else if (error?.response?.status === 403) {
              if (isInSupportMode()) {
                reject(error?.response?.data?.error);
                return;
              }
              removeLocalStorageOnSignOut();
              window.location.href = "/login";
            } else if (error?.response?.data?.error?.message?.code === "NotAuthorizedException") {
              if (isInSupportMode()) {
                goToSupportExpired();
                return;
              }
              this.updateAccessToken(() => this.put(url, resolve, reject, body, auth));
            } else {
              reject(error?.response?.data?.error);
            }
          });
      } else {
        this.updateAccessToken(() => this.put(url, resolve, reject, body, auth));
      }
    } else {
      axios
        .put(url, body, initObject)
        .then((data) => {
          resolve(data.data);
        })
        .catch((error) => {
          reject(error?.response?.data?.error);
        });
    }
  }

  static delete(url, resolve, reject, body, auth, extraHeaders) {
    const [alert, alert_notify] = UseAlert();
    let supportGrant = getSupportGrant();
    let token = localStorage.getItem("access_token");
    let headers = this.getHeaders();
    if (extraHeaders) {
      headers = { ...headers, ...extraHeaders };
    }

    if (auth) {
      if (supportGrant || token) {
        axios
          .delete(url, { data: body, headers })
          .then((data) => {
            resolve(data.data);
          })
          .catch((error) => {
            if (error.response?.data?.error?.message) {
              alert_notify("error", error.response.data.error.message);
            }
            if (error?.response?.status === 401) {
              if (isInSupportMode()) {
                goToSupportExpired();
                return;
              }
              if (url === "v1/user/sign_out") {
                removeLocalStorageOnSignOut();
                window.location.href = "/login";
              } else {
                this.updateAccessToken(() => this.delete(url, resolve, reject, body, auth));
              }
            } else if (error?.response?.status === 403) {
              if (isInSupportMode()) {
                reject(error?.response?.data?.error);
                return;
              }
              removeLocalStorageOnSignOut();
              window.location.href = "/login";
            } else if (error?.response?.data?.error?.message?.code === "NotAuthorizedException") {
              if (isInSupportMode()) {
                goToSupportExpired();
                return;
              }
              this.updateAccessToken(() => this.delete(url, resolve, reject, body, auth));
            } else {
              reject(error?.response?.data?.error);
            }
          });
      } else {
        this.updateAccessToken(() => this.delete(url, resolve, reject, body, auth));
      }
    } else {
      axios
        .delete(url, body, headers)
        .then((data) => {
          resolve(data.data);
        })
        .catch((error) => {
          reject(error?.response?.data?.error);
        });
    }
  }

  static updateAccessToken(callback) {
    if (isInSupportMode()) {
      goToSupportExpired();
      return false;
    }
    let refresh_token = localStorage.getItem("refresh_token");
    let email = localStorage.getItem("email");
    let body = { refresh_token, email };
    if (!refresh_token) {
      window.location.href = "/login";
      removeLocalStorageOnSignOut();
      return false;
    }
    axios
      .post(rest_api_url.refresh_token, body)
      .then((data) => {
        localStorage.setItem("access_token", data?.data?.access_token);
        callback && callback();
      })
      .catch((error) => {
        setTimeout(() => {
          removeLocalStorageOnSignOut();
          window.location.href = "/login";
          return false;
        }, 500);
      });
  }

  static getHeaders() {
    const supportGrant = getSupportGrant();
    if (supportGrant) {
      return { "x-support-grant": supportGrant };
    }
    let token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return headers;
  }
}
